<div class="select-container" [class.disabled]="disabled">
  <hyperkit-typography
    class="select-label"
    *ngIf="label && showLabel"
    variant="label1"
    color="inherit"
  >
    {{ label }}
  </hyperkit-typography>

  <div class="select-wrapper">
    <!-- Main select field -->
    <div
      class="select-field"
      [class.active]="state === 'active' && !disabled"
      [class.hover]="state === 'hover' && !disabled"
      [class.focused]="state === 'focused' && !disabled"
      [class.filled]="state === 'filled' && !disabled"
      [class.inactive]="state === 'inactive' || disabled"
      [class.error]="state === 'error' && !disabled"
      (click)="!disabled && toggleDropdown()"
      (mouseenter)="!disabled && onMouseEnter()"
      (mouseleave)="!disabled && onMouseLeave()"
      tabindex="0"
      (keydown.enter)="!disabled && toggleDropdown()"
      (keydown.space)="!disabled && toggleDropdown()"
    >
      <div class="select-value">
        <hyperkit-typography
          [class.placeholder]="!selectedDisplayText"
          variant="body1"
          color="inherit"
        >
          {{ selectedDisplayText || placeholder }}
        </hyperkit-typography>
      </div>

      <div class="select-arrow">
        <hyperkit-icon
          icon="chevron-down"
          color="inherit"
          size="medium"
        ></hyperkit-icon>
      </div>
    </div>
  </div>

  <!-- Dropdown options -->
  <div class="select-dropdown" *ngIf="isOpen && !disabled">
    <hyperkit-dropdown-menu [isVisible]="isOpen">
      <hyperkit-dropdown-menu-section-header
        *ngIf="sectionHeader"
        [label]="sectionHeader"
      ></hyperkit-dropdown-menu-section-header>
      <hyperkit-dropdown-menu-item
        *ngFor="let option of internalOptions"
        [label]="option.text"
        [selected]="
          (selectedOption && option.id === selectedOption.id) || false
        "
        (click)="selectOption(option)"
        (keydown.enter)="selectOption(option)"
        (keydown.space)="selectOption(option)"
      >
      </hyperkit-dropdown-menu-item>
    </hyperkit-dropdown-menu>
  </div>
</div>
